module.exports = __webpack_public_path__ + "assets/img/wback3.3177bd3d.png";